// extracted by mini-css-extract-plugin
export default {"faqSection":"FaqBlock-module--faqSection--65fa3","title":"FaqBlock-module--title--e44a7","content":"FaqBlock-module--content--1db48"};